export default __webpack_public_path__ + "static/media/logo.f9f2667e.png";